import * as React from 'react';
import Input from './Input';
import { Customer, CartProduct } from '../models/interfaces';
import { OrderFormStore } from '../stores/OrderFormStore';
import VirtualizedSelect from 'react-virtualized-select';

interface OrderFormCustomerProps {
  customers: Array<Customer>;
  cartProducts: Array<CartProduct>;
  orderFormStore: OrderFormStore;
  selectedCustomers: Array<Customer>;
}

interface OrderFormCustomerState {
  selectedCustomers: Array<{
    value: string;
    label: string;
  }>;
}

class OrderFormCustomer extends React.Component<OrderFormCustomerProps, OrderFormCustomerState> {
  constructor(props: OrderFormCustomerProps) {
    super(props);
    this.state = {
      selectedCustomers: []
    };
  }

  customerChange(selectedCustomers: Array<{ value: string, label: string }>) {
    if (selectedCustomers.length) {
      this.setState({ selectedCustomers: selectedCustomers });

      let customers: Customer[] = [];

      selectedCustomers.map(c => {
        let foundCustomer = this.getCustomer(c.value);
        if (foundCustomer) {
          customers.push(foundCustomer);
        }
      });

      customers.map(c => {
        if (!this.props.selectedCustomers.find(_c => c.No === _c.No)) {
          this.props.orderFormStore.addCustomer(c);
        }
      });

    } else {
      this.setState({ selectedCustomers: [] });
      this.props.orderFormStore.clearCustomer();
    }
  }

  removeCustomer(customer: Customer, index: number) {
    if (customer) {
      this.props.orderFormStore.removeCustomer(customer, index);
      if (customer.No !== '9999') {
        this.setState({
          selectedCustomers: this.state.selectedCustomers.filter(c => c.value !== customer.No)
        });
      }
    }
  }

  getCustomer(customerId: string) {
    return this.props.customers.find(c => c.No === customerId);
  }

  isCartEmpty() {
    return this.props.cartProducts.length === 0 ? true : false;
  }

  addNewCustomer() {
    this.props.orderFormStore.addCustomer({
      No: '9999',
      Name: '',
      Name2: '',
      Address: '',
      company: '',
      City: '',
      Key: '',
      Post_Code: ''
    });
  }

  /*addTestCustomers() {
    for (let i=1;i<=100;i++) {
      this.props.orderFormStore.addCustomer({
        No: '9999',
        Name: `Test${i}`,
        Name2: `Testi${i}`,
        Address: `Testitie ${i}`,
        company: '',
        City: 'HELSINKI',
        Key: '',
        Post_Code: '00002'
      });
    }
  }*/

  render() {

    const orderFormStore = this.props.orderFormStore;
    const selectedCustomers = this.props.selectedCustomers;

    const customerNameChange = (c: Customer, i: number, name: string) =>
      orderFormStore.setCustomerName(c, i, name);
    const customerCityChange = (c: Customer, i: number, city: string) =>
      orderFormStore.setCustomerCity(c, i, city);
    const customerZipChange = (c: Customer, i: number, zip: string) =>
      orderFormStore.setCustomerZip(c, i, zip);
    const customerAddressChange = (c: Customer, i: number, address: string) =>
      orderFormStore.setCustomerAddress(c, i, address);
    const customerRecipentNameChange = (c: Customer, i: number, name: string) =>
      orderFormStore.setCustomerRecipentName(c, i, name);
    const customerSecondAddressChange = (c: Customer, i: number, address: string) =>
      orderFormStore.setCustomerSecondAddress(c, i, address);

    return (
      <div className={this.isCartEmpty() ? 'box box--tabbed box--disabled' : 'box box--tabbed'}>
        <div className="box__title"><h2>Vastaanottajan tiedot</h2></div>
        <div className="box__content">
          <div className="input-wrapper input-wrapper--full">
            <label htmlFor="customer-selector">Valitse vastaanottaja</label>
            <VirtualizedSelect
              options={this.props.customers.map(c => {
                return { value: c.No, label: c.Name };
              })}
              multi={true}
              removeSelected={false}
              value={this.state.selectedCustomers}
              placeholder="Valitse"
              noResultsText="Ei tuloksia"
              onChange={(e: [{ value: string, label: string }]) => this.customerChange(e)}
            />
            <button
              className="button"
              onClick={() => this.addNewCustomer()}
            >Lisää uusi asiakas
            </button>
            {/*<button
              className="button"
              onClick={() => this.addTestCustomers()}
            >
              Lisää 100 testiasiakasta
            </button>*/}
          </div>
          <div className="table table--customer">
            <div className="row row--header">
              <div className="cell">Poista</div>
              <div className="cell">Asiakkaan nimi</div>
              <div className="cell">Vastaanottajan nimi</div>
              <div className="cell">Osoite</div>
              <div className="cell">Osoite 2</div>
              <div className="cell">Postinumero</div>
              <div className="cell">Kaupunki</div>
            </div>
            {
              selectedCustomers.map((customer, index) => {
                if (customer.No === '9999') {
                  return (
                    <div className="row row--content" key={index}>
                      <div className="cell">
                        <button
                          onClick={() => this.removeCustomer(customer, index)}
                          className="button button--notice button--small"
                        >X
                        </button>
                      </div>
                      <div className="cell">
                        <Input
                          id={'customer-name'}
                          type={'text'}
                          placeholder={'Nimi'}
                          value={customer.Name}
                          onChange={value => customerNameChange(customer, index, value)}
                          disabled={false}
                          required={true}
                        />
                      </div>
                      <div className="cell">
                        <Input
                          id={'recipient-name'}
                          type={'text'}
                          placeholder={'Nimi'}
                          value={customer.Name2}
                          onChange={value => customerRecipentNameChange(customer, index, value)}
                          disabled={false}
                          required={true}
                        />
                      </div>
                      <div className="cell">
                        <Input
                          id={'customer-address'}
                          type={'text'}
                          placeholder={'Osoite'}
                          value={customer.Address}
                          onChange={value => customerAddressChange(customer, index, value)}
                          disabled={false}
                          required={true}
                        />
                      </div>
                      <div className="cell">
                        <Input
                          id={'customer-address'}
                          type={'text'}
                          placeholder={'Osoite 2'}
                          value={customer.Address2}
                          onChange={value => customerSecondAddressChange(customer, index, value)}
                          disabled={false}
                          required={true}
                        />
                      </div>
                      <div className="cell">
                        <Input
                          id={'customer-zip'}
                          type={'text'}
                          placeholder={'Postinumero'}
                          value={customer.Post_Code}
                          onChange={value => customerZipChange(customer, index, value)}
                          disabled={false}
                          required={true}
                        />
                      </div>
                      <div className="cell">
                        <Input
                          id={'customer-city'}
                          type={'text'}
                          placeholder={'Kaupunki'}
                          value={customer.City}
                          onChange={value => customerCityChange(customer, index, value)}
                          disabled={false}
                          required={true}
                        />
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div className="row row--content" key={index}>
                      <div className="cell">
                        <button
                          onClick={() => this.removeCustomer(customer, index)}
                          className="button button--notice button--small"
                        >X
                        </button>
                      </div>
                      <div className="cell">
                        <span>{customer.Name}</span>
                        <div className="input-wrapper hidden">
                          <label htmlFor="customer-name">Asiakkaan nimi</label>
                          <Input
                            id={'customer-name'}
                            type={'text'}
                            placeholder={'Nimi'}
                            value={customer.Name}
                            onChange={value => null}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="cell">
                        <Input
                          id={'recipient-name'}
                          type={'text'}
                          placeholder={'Vastaanottajan nimi'}
                          value={customer.Name2}
                          onChange={value => customerRecipentNameChange(customer, index, value)}
                          disabled={false}
                          required={false}
                        />
                      </div>
                      <div className="cell">
                        <span>{customer.Address}</span>
                        <div className="input-wrapper hidden">
                          <label htmlFor="customer-address">Osoite</label>
                          <Input
                            id={'customer-address'}
                            type={'text'}
                            placeholder={'Osoite'}
                            value={customer.Address}
                            onChange={value => null}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="cell">
                        <Input
                          id={'customer-address2'}
                          type={'text'}
                          placeholder={'Osoite 2'}
                          value={customer.Address2}
                          onChange={value => customerSecondAddressChange(customer, index, value)}
                          disabled={false}
                          required={false}
                        />
                      </div>
                      <div className="cell">
                        <span>{customer.Post_Code}</span>
                        <div className="input-wrapper hidden">
                          <label htmlFor="customer-zip">Postinumero</label>
                          <Input
                            id={'customer-zip'}
                            type={'text'}
                            placeholder={'Postinumero'}
                            value={customer.Post_Code}
                            onChange={value => null}
                            disabled={true}
                          />
                        </div>
                      </div>
                      <div className="cell">
                        <span>{customer.City}</span>
                        <div className="input-wrapper hidden">
                          <label htmlFor="customer-zip">Kaupunki</label>
                          <Input
                            id={'customer-city'}
                            type={'text'}
                            placeholder={'Kaupunki'}
                            value={customer.City}
                            onChange={value => null}
                            disabled={true}
                          />
                        </div>
                      </div>
                    </div>
                  );
                }
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default OrderFormCustomer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/OrderFormCustomer.tsx